import { Injectable } from '@angular/core';
import { Router, UrlTree } from '@angular/router';
import { GuardService } from '@app/core';
import { PartialUrl } from 'src/app/core/enums/partial-url.enum';

/**
 * Province in v2 Guard
 */
@Injectable()
export class ProvinceInV2Guard {
	/**
	 * Province in v2
	 *
	 * @param _router router
	 * @param _guardService guard service
	 */
	constructor(
		private _router: Router,
		private _guardService: GuardService,
	) {}

	/**
	 * Checks if the user can activate an element or event
	 *
	 * @returns true if the user can active it
	 */
	canActivate(): boolean | UrlTree {
		return this._provinceInV2();
	}

	/**
	 * Checks if the user can load an element or event
	 *
	 * @returns true if the user can load it
	 */
	canLoad(): boolean | UrlTree {
		return this._provinceInV2();
	}

	/**
	 * Checks if the user can activate children
	 *
	 * @returns true if the user can active children
	 */
	canActivateChild(): boolean | UrlTree {
		return this._provinceInV2();
	}

	/**
	 * Checks if the province is included in v2
	 *
	 * @returns true if the user can access to the questionnaire home page or redirects if the access is denied
	 */
	private _provinceInV2(): boolean | UrlTree {
		if (this._guardService.canAccessQuestionnaireHome()) {
			return true;
		} else {
			return this._router.parseUrl(PartialUrl.HOME);
		}
	}
}
